<template>
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="foot-logo">
                        <img src="/img/logo-footer.svg" alt="">
                    </div>
                   <p class="Raleway min p-white">Made with <img src="/img/icon/like.svg" alt=""> in Sweden</p>

                </div>

                <div class="col-lg-6 d-flex align-items-stretch">
                    <div class="foot-nav">
                        <div class="row justify-content-center align-items-stretch">
                            <div class="col-lg-5 col-md-6 d-flex flex-column justify-content-between">
                                <router-link :class="'foot-links'" :to="{name: 'index'}">
                                    List of Companies
                                </router-link>
                                <router-link :class="'foot-links'"  :to="{name: 'index'}">
                                    Legal terms
                                </router-link>

                            </div>
                            <div class="col-lg-5 col-md-6 d-flex flex-column justify-content-between">
                                <router-link :class="'foot-links'"  :to="{name: 'index'}">
                                    Contact Us
                                </router-link>
                                <p class="Raleway min p-white swed-links">
                                    <img src="/img/icon/sweden.svg" alt="">
                                    <!--<img src="/img/icon/united-kingdom.svg" alt="">-->
                                    <router-link  :to="{name: 'index'}">
                                        Show site in Swedish
                                    </router-link>

                                </p>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="col-lg-3">
                    <p class="min-min foot-info p-white">Allmän information</p>
                    <p class="min foot-info p-white">TecknaEl.se </p>
                    <p class="min foot-info p-white">Orgno: 444344-1235</p>
                </div>
            </div>
        </div>

    </footer>

</template>

<script>
    export default {
        name: "FootBlock",
    }
</script>
